import React from 'react';

const PrivacyPolicy: React.FC = () => {
    return (
        <>
        fgfgfgfgfgfgfgg
        </>
    );
}

export default PrivacyPolicy;